import React, {Component} from "react";
import {connect} from "react-redux";
import {AppState} from "../store/reducers";
import {RouteComponentProps, withRouter} from "react-router";
import {compose} from "redux";
import ArchiveOrderFilter from "../components/ArchiveOrderFilter";
import {IDictionary} from "../models/Dictionary";
import Loader from "../components/UI/Loader";
import Error from "../components/UI/Error";
import {getDictionaryCityEagers} from "../store/actions/dictionaryCityEagers";
import queryString from "query-string";
import {IOrderArchiveRequest} from "../models/Order";
import {getDictionaryOrderStatuses} from "../store/actions/dictionaryOrderStatuses";
import {archiveOrdersFilterReSelector} from "../store/reselectors/orders";


type ArchiveOrderFilterType = {
    filter?:IOrderArchiveRequest
    getDictionaryCityEagers: () => void
    getDictionaryOrderStatuses: () => void
    dictionaryCityEagers: IDictionary[]
    dictionaryCityEagersLoading: boolean
    dictionaryCityEagersError: string
    dictionaryOrderStatuses: IDictionary[]
    dictionaryOrderStatusesLoading: boolean
    dictionaryOrderStatusesError: string
}

class ArchiveOrderFilterContainer extends Component<ArchiveOrderFilterType & RouteComponentProps> {

    componentDidMount() {
        const {getDictionaryCityEagers, getDictionaryOrderStatuses} = this.props;
        getDictionaryCityEagers();
        getDictionaryOrderStatuses()
    }

    setFilterHandler = (form:IOrderArchiveRequest) => {
        const {history} = this.props;
        const nextQueryParams = queryString.stringify(form);
        history.push(`${history.location.pathname}?${nextQueryParams}`);
    };

    render() {
        const {filter, dictionaryCityEagers, dictionaryCityEagersLoading, dictionaryCityEagersError, getDictionaryCityEagers,
            dictionaryOrderStatuses, dictionaryOrderStatusesLoading,dictionaryOrderStatusesError, getDictionaryOrderStatuses} = this.props;

        if (dictionaryCityEagersLoading || dictionaryOrderStatusesLoading) {
            return <Loader/>
        }

        if (dictionaryCityEagersError) {
            return <Error error={dictionaryCityEagersError} refresh={getDictionaryCityEagers}/>
        }

        if (dictionaryOrderStatusesError) {
            return <Error error={dictionaryOrderStatusesError} refresh={getDictionaryOrderStatuses}/>
        }

        if (!!dictionaryCityEagers.length && !!dictionaryOrderStatuses.length) {
            return <ArchiveOrderFilter
                filter={filter}
                dictionaryCityEagers={dictionaryCityEagers}
                dictionaryOrderStatuses={dictionaryOrderStatuses}
                setFilterHandler={this.setFilterHandler}
            />
        }
        return null
    }
}

const mapStateToProps = ({dictionaryCityEagers, dictionaryOrderStatuses}: AppState, props: RouteComponentProps) => {
    return {
        filter:archiveOrdersFilterReSelector(props),
        dictionaryCityEagers: dictionaryCityEagers.data,
        dictionaryCityEagersLoading: dictionaryCityEagers.loading,
        dictionaryCityEagersError: dictionaryCityEagers.error,
        dictionaryOrderStatuses: dictionaryOrderStatuses.data,
        dictionaryOrderStatusesLoading: dictionaryOrderStatuses.loading,
        dictionaryOrderStatusesError: dictionaryOrderStatuses.error
    }
};

const mapDispatchToProps = {
    getDictionaryCityEagers,
    getDictionaryOrderStatuses
};

export default compose<React.ComponentClass>(withRouter, connect(mapStateToProps, mapDispatchToProps))(ArchiveOrderFilterContainer);
